import { graphql, Environment } from "react-relay";
import { LoaderArgs } from "../../utils/route";
import { OAuth2AuthorizePageQuery as OAuth2AuthorizePageQueryType } from "./__generated__/OAuth2AuthorizePageQuery.graphql";
import { preload, usePreloaded } from "../../utils/relay";

export type {
  OAuth2AuthorizePageQuery as OAuth2AuthorizePageQueryType,
  Scope,
} from "./__generated__/OAuth2AuthorizePageQuery.graphql";

export const OAuth2AuthorizePageQuery = graphql`
  query OAuth2AuthorizePageQuery($input: Oauth2AuthorizeInput!) {
    viewer @ifAllowed {
      id
    }
    oauth2Authorize(input: $input) {
      scope
      oauth2Config {
        name
        description
      }
      redirectUri
      valid
    }
  }
`;

export const oauth2AuthorizePageQueryLoader = (environment: Environment) => {
  return ({ request }: LoaderArgs) => {
    const url = new URL(request.url);
    const clientId = url.searchParams.get("client_id") || "";
    const state = url.searchParams.get("state");
    const redirectUri = url.searchParams.get("redirect_uri");
    const scope = url.searchParams.get("scope");
    return preload<OAuth2AuthorizePageQueryType>(
      environment,
      OAuth2AuthorizePageQuery,
      { input: { clientId, state, redirectUri, scope } },
    );
  };
};

export const useOAuth2AuthorizePageQuery = () =>
  usePreloaded<OAuth2AuthorizePageQueryType>();
